import { tv } from 'tailwind-variants';

import { Image } from '@frontendmentorio/design-system-v2';

const imageStyles = tv({
  base: [
    'col-start-1',
    'row-start-1',
    'duration-300',
    'max-w-none',
    'opacity-0',
    'transition-opacity',
    'w-full',
  ],
  variants: {
    isActive: {
      true: ['opacity-100'],
    },
  },
});

export default function Images({ activeStep }) {
  return (
    <div className="grid desktop:w-1/2">
      <Image
        alt=""
        className={imageStyles({ isActive: activeStep === 1 })}
        height={964}
        quality={100}
        src="/static/images/home-how-it-works-1.webp"
        width={1160}
      />

      <Image
        alt=""
        className={imageStyles({ isActive: activeStep === 2 })}
        height={964}
        quality={100}
        src="/static/images/home-how-it-works-2.webp"
        width={1160}
      />

      <Image
        alt=""
        className={imageStyles({ isActive: activeStep === 3 })}
        height={964}
        quality={100}
        src="/static/images/home-how-it-works-3.webp"
        width={1160}
      />

      <Image
        alt=""
        className={imageStyles({ isActive: activeStep === 4 })}
        height={964}
        quality={100}
        src="/static/images/home-how-it-works-4.webp"
        width={1160}
      />
    </div>
  );
}
